import { useEffect, useState } from 'react';
import './Timer.css';
import { useNow } from '../../hooks/useNow';
import { formatTime } from '../../utils/timer';

const Timer = ({ id, countdown, text, test, autoCount = false, reverseProgress = false, externalNow }) => {
    const [localStartAt, setLocalStartAt] = useState(null);

    // Используем переданное startAt (test), если autoCount=false, иначе локальное
    const startAt = autoCount ? null : test;

    // Вычисляем текущее время
    const nowFromHook = useNow(1000, true);
    const now = autoCount ? nowFromHook : externalNow;

    // Рассчитываем время для autoCount (отсчёт до следующего часа по МСК)
    let countDown;
    if (autoCount) {
        // Получаем текущее время в часовом поясе Москвы (UTC+3)
        const moscowTime = new Date(now);
        moscowTime.setHours(moscowTime.getUTCHours() + 3);

        // Получаем минуты и секунды текущего времени по МСК
        const minutes = moscowTime.getUTCMinutes();
        const seconds = moscowTime.getUTCSeconds();

        // Вычисляем, сколько секунд осталось до следующего часа
        const secondsUntilNextHour = (60 - minutes - 1) * 60 + (60 - seconds);
        countDown = secondsUntilNextHour * 1000;
    } else {
        // Для autoCount=false используем переданное countdown напрямую
        countDown = countdown;
    }

    const secondsLeft = Math.ceil(countDown / 1000);

    // Прогресс-бар: 22 элемента, активные зависят от прогресса
    const totalBars = 22;
    const totalDuration = autoCount ? 3600000 : 600000; // 10 минут для AddWallet
    const activeBars = Math.ceil((countDown / totalDuration) * totalBars);

    const isCountEnd = countDown === 0;
    const isActive = (autoCount || !!startAt) && countDown > 0;

    return (
        <div className="timer">
            <div className="timer__mainBlock">
                <div className="timer__leftBlock">
                    <div className="timer__countdown">
                        {formatTime(secondsLeft)}
                    </div>
                    <div className="timer__text appearanceAnimation">{text}</div>
                </div>
                <ul className="timer__progress">
                    {Array.from({ length: totalBars }).map((_, index) => (
                        <li
                            key={index}
                            className={reverseProgress ? (index >= activeBars ? 'active' : '') : (index < activeBars ? 'active' : '')}
                        ></li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default Timer;